<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <!-- <div class="modal-header">
          <h4 class="modal-title">Add User</h4>
        </div> -->
        <!-- Modal content-->
        <!-- <perfect-scrollbar class="modal-body-scrollbar"> -->
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
              <div class="modal_close_btn">
                <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
              </div>
              <div class="status_details">
                <div class="status_img">
                  <img src="../../../../../assets/images/icons/success.svg" alt="">
                </div>
                <div class="status_content">
                  <h4> You faild to subscribe ! </h4>
                  <!-- <p>You can Track Order on My Orders</p> -->
  
                  <!-- <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="dont_account" *ngIf="payment_mode === 'ONLINE'">
                      <p> Don't have Account with Vendor <a (click)="accountRequest()">Click Here</a>
                      </p>
                    </div>
                    <button class="btn btn-sm global-btn" mat-button (click)="dialogClose()">Continue Shopping</button>
                  </div> -->
  
                </div>
              </div>
            </div>
          </div>
        <!-- </perfect-scrollbar> -->
        <!-- Modal-Footer -->
        <!-- <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
              <span>Cancel</span>
            </button>
            <button mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span>Save</span>
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  